<template>
  <div class="app-wrapper">
    <div class="header">
      <el-button type="primary" style="float: right;" @click="handleAddNewApp">点击新增</el-button>
    </div>
    <!-- 表格区域 -->
    <div class="table">
      <el-table ref="tableRef" :data="appVersionList" v-loading="tableLoading" stripe border>
        <el-table-column type="index" label="序号" width="60" align="center" :resizable="false"></el-table-column>
        <el-table-column
          prop="appName"
          label="APP名称"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="appCode" label="APP编码" align="center" :resizable="false"></el-table-column>
        <el-table-column label="系统类型" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <span>{{ row.appType === 1 ? 'Android' : 'ios' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="downloadAddress"
          label="下载地址"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="updateContent"
          label="更新内容"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="version" label="版本号" align="center" :resizable="false"></el-table-column>
        <el-table-column label="状态" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <span>{{ row.status === 1 ? '启用' : '停用' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top">
              <i
                class="iconfont iconcaozuo-1xiugai_1"
                style="margin-right: 16px;"
                @click="handleEditApp(row)"
              ></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <i class="iconfont iconcaozuo-2shanchu_1" @click="handleDelete(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- page -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.current"
        :page-size="queryForm.size"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <!-- 新增/编辑app版本对话框 -->
    <el-dialog
      :title="appDialogTitle"
      :visible.sync="appDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
      @close="closeAppDialog"
    >
      <el-form ref="paramsFormRef" :rules="paramsFormRules" :model="paramsForm" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="appName" label="app名称">
              <el-input v-model.trim="paramsForm.appName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="appCode" label="app编码">
              <el-input v-model.trim="paramsForm.appCode" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="appType" label="系统类型">
              <el-radio-group
                v-model="paramsForm.appType"
                @change="handleChangeAppType"
                :disabled="!!paramsForm.id"
              >
                <el-radio-button label="1">Android</el-radio-button>
                <el-radio-button label="2">ios</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="version" label="版本号">
              <el-input v-model.trim="paramsForm.version" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="status" label="状态">
              <el-radio-group v-model="paramsForm.status">
                <el-radio-button label="1">启用</el-radio-button>
                <el-radio-button label="0">停用</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="updateStyle" label="更新风格">
              <el-radio-group v-model="paramsForm.updateStyle">
                <el-radio-button label="2">强制更新</el-radio-button>
                <el-radio-button label="1">推荐更新</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="updateContent" label="更新内容">
              <el-input
                type="textarea"
                :rows="5"
                v-model.trim="paramsForm.updateContent"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="paramsForm.appType == 1">
            <el-form-item prop="downloadAddress" label="应用文件">
              <UploadFile
                accept-type=".apk"
                :defaultList="defaultList"
                @get-file-data="getFileData"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-else>
            <el-form-item prop="downloadAddress" label="文件URL">
              <el-input v-model.trim="paramsForm.downloadAddress" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer">
        <el-button style="margin-right:6px" @click="closeAppDialog">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import appApi from 'api/home/app-mangement.js';
import UploadFile from 'components/UploadImg.vue';

export default {
  components: { UploadFile },
  data() {
    return {
      total: 0,
      queryForm: {
        current: 1,
        size: 10
      },
      appVersionList: [],
      tableLoading: true,
      appDialogTitle: '新增APP',
      appDialogVisible: false,
      defaultList: [],
      paramsForm: {
        id: '', // 编辑用
        appCode: '',
        appName: '',
        appType: '1',
        downloadAddress: '',
        version: '',
        status: '1',
        updateContent: '',
        updateStyle: '2'
      },
      paramsFormRules: {
        appName: [{ required: true, message: '请输入app名称', trigger: 'blur' }],
        appCode: [{ required: true, message: '请输入app编码', trigger: 'blur' }],
        appType: [{ required: true, message: '请选择app类型', trigger: 'change' }],
        downloadAddress: [{ required: true, message: '请上传文件或输入URL', trigger: 'change' }],
        version: [{ required: true, message: '请输入app版本号', trigger: 'blur' }],
        status: [{ required: true, message: '请选择app状态', trigger: 'change' }],
        updateContent: [{ required: true, message: '请输入更新内容', trigger: 'blur' }],
        updateStyle: [{ required: true, message: '请选择更新风格', trigger: 'change' }]
      },
      btnLoading: false,
      currentAppDetail: {}
    };
  },
  created() {
    this.getAppVersionListData();
  },
  methods: {
    // 查询列表
    getAppVersionListData() {
      this.tableLoading = true;
      appApi
        .getAppVersionList(this.queryForm)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.data.total;
            this.appVersionList = res.data.data.records;
          }
          // else {
          //   this.$message.error(res.data.message);
          // }

          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.current = 1;
      this.queryForm.size = val;
      this.getAppVersionListData();
    },
    handleCurrentChange(val) {
      this.queryForm.current = val;
      this.getAppVersionListData();
    },
    // app类型选择事件
    handleChangeAppType(val) {
      this.paramsForm.downloadAddress = '';
    },
    // 上传文件获取id
    getFileData(data) {
      this.paramsForm.downloadAddress = data.join(',');
    },
    // 点击新增
    handleAddNewApp() {
      this.appDialogTitle = '新增APP';
      this.appDialogVisible = true;
    },
    // 点击编辑
    handleEditApp(row) {
      // console.log(row);
      this.currentAppDetail = row;
      this.appDialogTitle = '编辑APP';
      this.appDialogVisible = true;

      this.$nextTick(() => {
        this.paramsForm.id = row.id;
        this.paramsForm.appCode = row.appCode;
        this.paramsForm.appName = row.appName;
        this.paramsForm.appType = row.appType + '';
        this.paramsForm.downloadAddress = row.fileId || row.downloadAddress;
        this.paramsForm.version = row.version;
        this.paramsForm.status = row.status + '';
        this.paramsForm.updateContent = row.updateContent;
        this.paramsForm.updateStyle = row.updateStyle + '';

        if (row.fileId) {
          const fileInfo = {};
          fileInfo.name = row.fileName;
          fileInfo.id = row.fileId;
          this.defaultList.push(fileInfo);
        }
      });

      // console.log(this.paramsForm);
    },
    // 关闭对话框
    closeAppDialog() {
      this.appDialogVisible = false;
      this.$refs.paramsFormRef.resetFields();
      this.paramsForm.id = '';
      this.defaultList = [];
    },
    // 点击确定
    handleSubmit() {
      this.$refs.paramsFormRef.validate(valid => {
        if (!valid) {
          return;
        }
        // console.log(this.paramsForm);
        // return;
        // 无id为新增，有id为编辑
        if (this.paramsForm.id) {
          this.postEditAppData();
        } else {
          this.postNewAppData();
        }
      });
    },
    // 新增接口
    postNewAppData() {
      this.btnLoading = true;
      appApi
        .postNewApp(this.paramsForm)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('新增APP成功');
            this.closeAppDialog();
            this.queryForm.current = 1;
            this.getAppVersionListData();
          }
          // else {
          //   this.$message.error(res.data.message);
          // }

          this.btnLoading = false;
        })
        .catch(err => {
          this.btnLoading = false;
        });
    },
    //编辑接口
    postEditAppData() {
      this.btnLoading = true;
      appApi
        .postEditAPP(this.paramsForm)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('编辑APP成功');
            this.closeAppDialog();
            this.getAppVersionListData();
          }
          // else {
          //   this.$message.error(res.data.message);
          // }

          this.btnLoading = false;
        })
        .catch(err => {
          this.btnLoading = false;
        });
    },
    // 点击删除
    handleDelete(row) {
      this.$confirm('将删除所选APP，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.postDeleteAppData(row.id);
        })
        .catch(() => {});
    },
    // 删除接口
    postDeleteAppData(id) {
      appApi.postDeleteApp({ id }).then(res => {
        if (res.data.code === 200) {
          this.queryForm.current = 1;
          this.queryForm.size = 10;
          this.getAppVersionListData();
          this.$message.success('删除APP成功');
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.app-wrapper {
  padding: 16px;

  .header {
    height: 40px;
    margin-bottom: 16px;
  }

  .footer {
    text-align: right;
  }

  .page {
    margin: 16px 0;
    float: right;
  }
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
</style>
